import {
  MUTATION_SET_PROCESS_STATE,
  MUTATION_SET_SELECTED_FILE,
  MUTATION_SET_UPLOAD_PROGRESS,
  MUTATION_SET_VALIDATION_RESULT,
  MUTATION_SET_PROCESS_RESULT,
  MUTATION_SET_UPLOAD_DRAWER_OPEN,
  MUTATION_SET_DELETE_DRAWER_OPEN,
  MUTATION_SET_CURRENT_STEP,
  MUTATION_SET_ERRORS,
  MUTATION_RESET_PROCESS
} from "../mutations.js";

export default {
  [MUTATION_SET_PROCESS_STATE](state, newState) {
    state.processState = newState;
  },
  [MUTATION_SET_SELECTED_FILE](state, file) {
    state.selectedFile = file;
  },
  [MUTATION_SET_UPLOAD_PROGRESS](state, progress) {
    state.uploadProgress = progress;
  },
  [MUTATION_SET_VALIDATION_RESULT](state, result) {
    state.validationResult = result;
  },
  [MUTATION_SET_PROCESS_RESULT](state, result) {
    state.processResult = result;
  },
  [MUTATION_SET_UPLOAD_DRAWER_OPEN](state, isOpen) {
    state.uploadDrawerOpen = isOpen;
  },
  [MUTATION_SET_DELETE_DRAWER_OPEN](state, isOpen) {
    state.deleteDrawerOpen = isOpen;
  },
  [MUTATION_SET_CURRENT_STEP](state, step) {
    state.currentStep = step;
  },
  [MUTATION_SET_ERRORS](state, errors) {
    state.errors = errors;
  },
  [MUTATION_RESET_PROCESS](state) {
    state.processState = 'IDLE';
    state.selectedFile = null;
    state.uploadProgress = 0;
    state.validationResult = null;
    state.processResult = null;
    state.currentStep = 1;
    state.errors = [];
  }
};
